import { RouterSelectors } from '@next/core-lib/router-store';
import { createSelector } from '@ngrx/store';

import { getCycleModuleState, getSelectedCycle } from './cycle.selectors';
import { BalancePerDeliveryLine } from '../../models/cycle.model';

export const getBalancesPerDeliveryLine = createSelector(getSelectedCycle, (cycle) =>
  !!cycle && !!cycle.balancesPerDeliveryLine ? cycle.balancesPerDeliveryLine : [],
);

export const getSelectedBalanceRowId = createSelector(
  RouterSelectors.getMergedRoute,
  (state) => state.params['balanceRowId'],
);

export const getSelectedBalanceRow = createSelector(
  getSelectedBalanceRowId,
  getBalancesPerDeliveryLine,
  (balanceRowId: string, balanceRows: Array<BalancePerDeliveryLine>) =>
    balanceRows
      ? balanceRows.find((d) => `${d.deliveryId}_${d.deliveryLineIdentifier}` === balanceRowId)
      : undefined,
);

export const getSelectedProduct = createSelector(
  getCycleModuleState,
  (state) => state.selectedProduct,
);

export const getCalculatedBalancesPerDeliveryLine = createSelector(getSelectedCycle, (cycle) =>
  cycle ? cycle.balancesPerDeliveryLine : [],
);

export const getRouteTransitionBalance = createSelector(
  getCycleModuleState,
  (state) => state.routeTransitionBalance,
);
